import type { ReactNode } from "react";
import { Col, Row } from "react-bootstrap";
import { ExpandableText } from "../Account/AccountProfileLayout";

type ProfileSectionProps = {
  title: string;
  children: ReactNode;
};

export function ProfileSection({ title, children }: ProfileSectionProps) {
  return (
    <section className="profile-section border rounded-3 overflow-hidden mb-3">
      <div className="profile-section-header px-3 py-2 border-bottom bg-light">
        <h3 className="h6 mb-0 fw-bold text-dark">{title}</h3>
      </div>
      <Row className="g-0">{children}</Row>
    </section>
  );
}

type ProfileFieldProps = {
  label: string;
  value: ReactNode;
  fullWidth?: boolean;
};

export function ProfileField({
  label,
  value,
  fullWidth = false,
}: ProfileFieldProps) {
  return (
    <Col
      xs={12}
      md={fullWidth ? 12 : 6}
      lg={fullWidth ? 12 : 4}
      className="border-bottom p-3 min-w-0"
    >
      <div className="small text-muted fw-semibold mb-1 text-truncate">{label}</div>
      <ExpandableText className="fw-semibold profile-field-value" clamp={fullWidth}>
        {value}
      </ExpandableText>
    </Col>
  );
}

export function profileValue(
  value: string | null | undefined,
  fallback: string,
): string {
  const trimmed = value?.trim();
  return trimmed || fallback;
}
